<template>
  <div>
  <div class="left_tree" v-show="showLeft">
    <a-spin :spinning="treeSpin" style="height: 100%">
      <div>
        <a-radio-group v-model="type" @change="handleChange">
          <a-radio-button value="dept">
            部门
          </a-radio-button>
          <a-radio-button value="customer">
            员工
          </a-radio-button>
        </a-radio-group>
        <vxe-button @click="closeAll" style="margin-top: 12px">清空</vxe-button>
      </div>
      <div class="tree-box" v-if="type === 'dept'">
        <a-tree
            v-model="checkedKeys"
            :show-icon="true"
            checkable
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="treeData"
            :selectable="false"
            :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
            @expand="onExpand"
            @check="onSelect"
        >
          <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
          <a-icon type="cluster" slot="region" style="color:#52c41a"/>
        </a-tree>
      </div>
      <div class="tree-box" v-if="type === 'customer'">
        <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"
              @change="checkedUser"></Tree>
      </div>
    </a-spin>
  </div>
  <div  class="right_table" :class="{showLeft:!showLeft}">
    <a-icon type="left-circle" class="close" @click="showLeft = false" v-if="showLeft"/>
    <a-icon type="right-circle" class="close" @click="showLeft = true" v-else/>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :otherParams="{'planMold':3,receiveDeptId,userId}"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <div class="status_box">
          <span class="status_item" :class="navSwitch == 0?'active':''" @click="changeNav(0)">厂家</span>
          <span class="status_item" :class="navSwitch == 1?'active':''" @click="changeNav(1)">经理部</span>
          <span class="status_item" :class="navSwitch == 2?'active':''" @click="changeNav(2)">经销商</span>
          <span class="status_item" :class="navSwitch == 3?'active':''" @click="changeNav(3)">销售顾问</span>
          <div class="btns_box">
            <vxe-button @click="addRow" v-if="navSwitch == 0">新增</vxe-button>
          </div>
        </div>
      </template>
      <template v-slot:operate="{row}">
        <vxe-button size="mini" v-if="finish && row.provideTypeName == '未下发' && navSwitch == 0" @click="editData(row)">编辑</vxe-button>
        <vxe-button size="mini" status="primary" @click="checkData(row)" v-if="navSwitch != 3">查看</vxe-button>
        <vxe-button size="mini" @click="issuedPlan(row)" v-if="navSwitch != 3 && row.provideTypeName == '未下发'">{{row.planClassify===1?'确认':'下发'}}</vxe-button>
        <a-popconfirm title="确定删除吗？" ok-text="确定" cancel-text="取消" @confirm="deleteTableRow(row)" v-if="finish && navSwitch == 0 && row.canDelete===1">
          <span class="icon" @click.stop="e => e.preventDefault()">
            <vxe-button size="mini">删除</vxe-button></span>
        </a-popconfirm>

      </template>
    </x-grid>

    <!-- 详情页 -->
    <formModal
        :title=title
        centered
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          :index="index"
          :navFlag="navFlag"
          :strainIdId="strainIdId"
          :importFlag="importFlag"
          :disabledDetail="disabledDetail"
          :navSwitch="navSwitch"
          v-if="editModalVisible"
          ref="form"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>
    <!--  查看数据 -->
    <a-modal
        title="查看完成情况"
        centered
        :footer="null"
        :maskClosable="true"
        v-model="showTransferPop"
        :width="1200"
        :closable="true"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <finishResult
          :transferIdArr="transferIdArr"
          v-if="showTransferPop"
          :planId="issuedId"
          :navSwitch="navSwitch"
          :deptOrUser="deptOrUser"
          ref="finishResult"
          @close="closeTransferPop"
      >
      </finishResult>
    </a-modal>
    <!--  查看数据 经销商-->
    <a-modal
        title="查看完成情况"
        centered
        :footer="null"
        :maskClosable="true"
        v-model="dealerProp"
        :width="1200"
        :closable="true"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <dealerFinishResult
          :transferIdArr="transferIdArr"
          v-if="dealerProp"
          :planId="issuedId"
          :deptOrUser="deptOrUser"
          :navSwitch="navSwitch"
          ref="finishResult"
          @close="closeTransferPop"
      >
      </dealerFinishResult>
    </a-modal>
    <!--  查看数据 销售顾问-->
    <a-modal
        title="查看完成情况"
        centered
        :footer="null"
        :maskClosable="true"
        v-model="userProp"
        :width="1200"
        :closable="true"
    >
      <!--      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数-->
      <userFinishResult
          :transferIdArr="transferIdArr"
          v-if="userProp"
          :planId="issuedId"
          :deptOrUser="deptOrUser"
          :navSwitch="navSwitch"
          ref="finishResult"
          @close="closeTransferPop"
      >
      </userFinishResult>
    </a-modal>
  </div>
  </div>

</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
import detailForm from "./leadPlanDetail";
import finishResult from "@/pages/web/activity/leadPlan/detail/finishResult"
import {dataApi} from "@/services/plan/leadPlan";
import userFinishResult from "@/pages/web/activity/leadPlan/detail/userFinishResult";
import dealerFinishResult from "@/pages/web/activity/leadPlan/detail/dealerFinishResult";
//新增的
import {XEUtils} from "@/utils/common/FormBase";
import Tree from "@/components/picker/Tree";

//新增的结束
console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除


const fac = XGrid.factory;

//列表接口
const url = api.plan.PLAN;

//主键
const rowId = "planId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("provideTypeName", "下发状态", 100),
  fac.makeColumn("receiveDeptName", "部门", 155),
  fac.makeColumn("receiveDeptUserName", "销售顾问", 155),
  fac.makeColumn("planNo", "线索计划编号", 130),
  fac.makeColumn("planName", "线索计划名称", 240),

  fac.makeColumn("qyNum", "牵引数量", 100),
  fac.makeColumn("zhNum", "载货数量", 100),
  fac.makeColumn("gcNum", "工程数量", 100),
  fac.makeColumn("zyNum", "专用数量", 100),
  fac.makeColumn("qkNum", "轻卡数量", 100),
  fac.makeColumn("xnyNum", "新能源数量", 100),

  fac.makeColumn("qyFinishNum", "牵引已完成", 100),
  fac.makeColumn("zhFinishNum", "载货已完成", 100),
  fac.makeColumn("gcFinishNum", "工程已完成", 100),
  fac.makeColumn("zyFinishNum", "专用已完成", 100),
  fac.makeColumn("qkFinishNum", "轻卡已完成", 100),
  fac.makeColumn("xnyFinishNum", "新能源已完成", 100),

  fac.makeColumn("planTime", "计划时间", 200),
  fac.makeColumn("provideTime", "下发时间", 200),
  fac.makeColumn({
    title: "操作",
    field: 'operate',
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 200,
    fixed:'right'
  }),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "provideType",
    title: "下发状态",
    type: "select",
    options: [
      {
        label:'已下发',
        value:'1'
      },
      {
        label:'未下发',
        value:'0'
      }
    ]
  },
  {
    field: "planNo",
    title: "线索计划编号",
  },
  {
    field: "planName",
    title: "线索计划名称",
  },
  {
    field: "planStartTime",
    title: "计划时间 ",
    type: "month",
  },
  // {
  //   field: "receiveDept",
  //   title: "经理部筛选 ",
  //   type: "select",
  //   options: [],
  //   display:"none"
  // },
  // {
  //   field: "deptId",
  //   title: "经销商筛选 ",
  //   type: "select",
  //   options: []
  // }
  // ,{
  //   field: "receiveDeptUserName",
  //   title: "销售顾问",
  //   type: "input",
  // },
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: false,
  addData: false,
  templatelSlots: "toolbarBtns",
});

async function loadBaseData() {
  let region = {
    isRegion: 1,
    isDealer: 0
  }
  let dealer = {
    isRegion: 0,
    isDealer: 1
  }
  localStorage.setItem('showUserName', 0)
  this.strainOptions =  await dataApi.activityType();
  this.regionOptions = await dataApi.selection({region});//经理部
  // 部门下拉处理
    this.regionOptions = this.regionOptions.data.map(v => {
      return {
        label: v.deptName,
        value: v.deptId
      }
    })
    this.regionOptions = [{
      value: '',
      label: '全部'
    }].concat(this.regionOptions);
    console.log(this.regionOptions)
    this.loadSearchOption({
      receiveDept: this.regionOptions,
    })

  // 经销商下拉处理
    this.dealerOptions = await dataApi.selection(dealer);//经销商
    this.dealerOptions = this.dealerOptions.data.map(v => {
      return {
        label: v.deptName,
        value: v.deptId
      }
    })
    this.dealerOptions = [{
      value: '',
      label: '全部'
    }].concat(this.dealerOptions)
    this.loadSearchOption({
      deptId: this.dealerOptions,
    })



}
//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

const popConfig = fac.makePopConfig(["password", "merchantsAuthorization", "finishResult"]);

export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm, finishResult,userFinishResult,dealerFinishResult,
    //新增的开始
    Tree
    //  新增的结束
  },
  /*watch: {
    $route: {
      handler() {
        if (this.$route.path === '/scrm/plan/1') {
          this.changeNav(this.$store.state.setting.navSwitch)
        }
      },
      immediate: true
    }
  },*/
  computed: {},
  mounted() {
    //  新增的
    this.init()
    //  新增的结束
    if (this.columns[13].field === 'qyFinishNum') {
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
      this.columns.splice(13, 1)
    }
  },
  data() {
    const vm = this
    return {
      //  新增的
      regionId: '', dealerId: '', deptId: '',userId:'',receiveDeptId:'',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      //  新增的结束
      navSwitch: 0,
      popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: [],
      finish: true,
      showTransferPop: false,
      dealerProp:false,
      userProp:false,
      transferIdArr: '',
      navFlag: 0,
      index: 0,
      title: "线索计划详情",
      issuedId:'',
      deptOrUser:0,
      disabledDetail:false,
      planId:'',
      strainIdId:'',
      importFlag:0,
      exportUrl:api.plan.MAIN+'?',
      createTypeFlag:'',
      exportConfig: {
        remote: true,
        beforeExportMethod({options}){
          console.log(options)
          console.log(vm)
          options.planMold = 3;
          options.createType = vm.createTypeFlag;
          return options
        },
        exportMethod({options}) {
          return vm.exportMethod({
            options
          })
        },
        types: ['xlsx'],
        modes: ['current', 'selected', 'all']
      },
      regionOptions:[]
    };
  },
  methods: {
    loadBaseData,
    addRow() {
      this.index = 0;
      this.title = '线索计划详情'
      this.disabledDetail = false;
      this.openEdit(0);
    },
    /*下发*/
    issuedPlan(row) {
      console.log(row);
      this.index = 1;
      this.planId = row.planId
      this.strainIdId=row.strainType
      this.disabledDetail = true;
      this.title = '下发线索计划'
      this.editRow(row)
    },
    //查看
    checkData(row) {
      if(this.navSwitch === 0){
        this.issuedId = row.planId;
        this.showTransferPop = true;
        this.deptOrUser = this.navFlag;
      } else if(this.navSwitch === 1){
        this.dealerProp = true
        this.issuedId = row.planId;
        this.deptOrUser = this.navFlag;
      }else if(this.navSwitch === 2){
        this.userProp = true
        this.issuedId = row.planId;
        this.deptOrUser = this.navFlag;
      }
    },
    editData(row) {
      console.log(row)
      this.index = 2;
      this.planId = row.planId;
      this.disabledDetail = false
      this.title = '线索计划详情'
      this.editRow(row)
    },
    updateRow({row}) {
      this.index = 2;
      this.planId = row.planId;
      this.title = "线索计划详情"
      this.disabledDetail = false;
      this.editRow(row)
    },
    closeTransfer() {
      this.showTransferPop = false;
    },
    //关闭弹窗
    closeTransferPop() {
      if(this.navSwitch === 0){
        this.showTransferPop = false;
      }else if(this.navSwitch === 1){
        this.dealerProp = false;
      }else if(this.navSwitch == 2){
        this.userProp = true;
      }
      this.refresh();
    },
    changeNav(status) { //切换nav状态
      this.navSwitch = status;
      if (this.navSwitch === 3 || this.navSwitch === 2) {
        this.navFlag = 1
      } else {
        this.navFlag = 0;
      }

      if(this.navSwitch == 2){
        localStorage.setItem('showUserName', 1)
      }else{
        localStorage.setItem('showUserName', 0)
      }

      if (this.navSwitch == 3 || this.navSwitch === 2) {
        this.importFlag = 1
      } else {
        this.importFlag = 0;
      }
      if (this.navSwitch === 0) {
        this.url = api.plan.PLAN;
        this.exportUrl = api.plan.MAIN+'?';
      } else if (this.navSwitch === 1 || this.navSwitch === 2) {
        if(this.navSwitch === 1){
          this.url = api.plan.RECEIVEDEPT + '?createType=2'
          this.exportUrl = api.plan.DEALER+'?';
          this.createTypeFlag = 2;
        }else{
          this.url = api.plan.RECEIVEDEPT + '?createType=3'
          this.exportUrl = api.plan.DEALER+'?';
          this.createTypeFlag = 3;
        }
      } else {
        this.url = api.plan.RECEIVEDEPTUSER + '?createType=4'
        this.exportUrl = api.plan.USER+'?'
      }
      console.log(this.navFlag);
      const vm = this;
      if (this.columns[2].field === 'provideTypeName' && status === 3) {
        this.columns.splice(2, 1)//去掉下发状态
        // let obj3 = {
        //   field: "finishNum",
        //   headerAlign: "center",
        //   resizable: true,
        //   sortable: false,
        //   title: "已完成",
        //   visible: true,
        //   width: 100
        // }
        // this.columns.splice(8, 0, obj3)
        // this.columns.splice(10, 1)
        let qyObj = {
          field: "qyFinishNum",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "牵引已完成",
          visible: true,
          width: 100
        }
        let zhObj = {
          field: "qyFinishNum",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "载货已完成",
          visible: true,
          width: 100
        }
        let gcObj = {
          field: "qyFinishNum",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "工程已完成",
          visible: true,
          width: 100
        }
        let zyObj = {
          field: "qyFinishNum",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "专用已完成",
          visible: true,
          width: 100
        }
        let qkObj = {
          field: "qyFinishNum",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "轻卡已完成",
          visible: true,
          width: 100
        }
        let xnyObj = {
          field: "qyFinishNum",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "新能源已完成",
          visible: true,
          width: 100
        }
        this.columns.splice(12, 0, xnyObj)
        this.columns.splice(12, 0, qkObj)
        this.columns.splice(12, 0, zyObj)
        this.columns.splice(12, 0, gcObj)
        this.columns.splice(12, 0, zhObj)
        this.columns.splice(12, 0, qyObj)
        this.columns.splice(19, 1)

      } else if (this.columns[2].field !== 'provideTypeName' && (status === 0 || status === 1 || status === 2)) {
        let obj = {
          field: "provideTypeName",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "下发状态",
          visible: true,
          width: 100
        }
        let obj2 = {
          field: "provideTime",
          headerAlign: "center",
          resizable: true,
          sortable: false,
          title: "下发时间",
          visible: true,
          width: 240
        }
        this.columns.splice(2, 0, obj)
        this.columns.splice(13, 6)

        // this.columns.splice(9, 1)
        this.columns.splice(14, 0, obj2)
      }
      this.$nextTick(() => {
        vm.refresh()
      })
    },
    deleteTableRow(row) {
      console.log(row)
      dataApi.deleteItem(row.planId).then(res => {
        if (res.code === 200) {
          window.location.reload();
        }
      });
    },
    //  新增的
    init() {
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },
    handleChange() {
      this.closeAll()
      this.init()
    },
    closeAll() {
      this.checkedKeys = []
      this.userId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      this.receiveDeptId=''
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            user.checked = false
          })
        }
        return item
      })
      this.selectedUser = []
      this.$nextTick(() => {
        this.refresh()
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []//三个数组
      checkedNodes.forEach(item => {//对象里的每一个
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
        } else {
          deptId.push(item.key)
        }
      })
      // this.regionId = regionId.toString()
      // this.dealerId = dealerId.toString()
      // this.deptId = deptId.toString()
      var newArr=regionId.concat(dealerId).concat(deptId)
      this.receiveDeptId=newArr.toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
      this.userId = this.selectedUser.map(item => {
        return item.userId
      }).toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },

    //  新增的结束
  },
};
</script>

<style lang="less" scoped>
.status_box {
  float: left;
  margin: 0 30px 12px 0;
  position: relative;
  top: -6px;

  .status_item {
    width: 120px;
    text-align: center;
    font-size: 15px;
    color: #333;
    line-height: 38px;
    display: inline-block;
    background-color: #E9F5FC;
    cursor: pointer;

    &.active {
      background-color: #D90B18;
      color: #fff;
    }
  }
}

.btns_box {
  float: right;
  margin-left: 30px;
  margin-top: 5px;
}

/deep/ .vxe-toolbar {
  height: 70px;
}
//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}

//新增的结束
</style>
